import AuthService from "@/services/AuthService";
import UserService from "@/services/UserService";

const state = () => ({
  user: null,
  justLoggedIn: false,
});

const getters = {
  isLoggedIn: (state) => {
    return state.user !== null;
  },

  isSpotifyConnected: (state, getters) => {
    return getters.isLoggedIn && state.user.spotifyId !== null;
  },

  isOnboarded: (state, getters) => {
    return getters.isLoggedIn && state.user.isOnboarded;
  },

  getAvatar: (state, getters) => {
    if (getters.isLoggedIn) {
      return state.user.avatar;
    }
    return 1;
  },

  getAllowsNotifications: (state, getters) => {
    return getters.isLoggedIn && state.user.allowsNotifications;
  },

  didJustLogin: (state) => {
    return state.justLoggedIn;
  },

  getUsername: (state) => {
    return state.user.email.split("@")[0];
  },

  getUserId: (state, getters) => {
    if (!getters.isLoggedIn) {
      return null;
    }
    return state.user.id;
  },

  getProfilePicture: (state, getters) => {
    const avatarNum = getters.getAvatar;
    if (avatarNum >= 0 && avatarNum <= 5) {
      return require("../../assets/dog" + avatarNum + ".png");
    }

    return require("../../assets/dog0.png");
  },
};

const actions = {
  loadMe({ commit }) {
    return UserService.me().then(
      (response) => {
        const user = response.data;
        console.log("User", user);
        commit("setUser", user);
        return Promise.resolve(user);
      },
      (error) => {
        commit("setUser", null);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },

  login({ commit }, data) {
    return AuthService.login(data).then(
      (response) => {
        const user = response.data;
        commit("setUser", user);
        return Promise.resolve(user);
      },
      (error) => {
        commit("setUser", null);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },

  register({ commit }, data) {
    return AuthService.register(data).then(
      (response) => {
        const user = response.data;
        commit("setUser", user);
        return Promise.resolve(user);
      },
      (error) => {
        commit("setUser", null);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },

  logout({ commit }) {
    AuthService.logout();
    commit("setUser", null);
  },

  updateOnboardingStatus({ commit }, isOnboarded) {
    UserService.updateOnboardingStatus(isOnboarded).then(
      (res) => {
        const user = res.data;
        commit("setUser", user);
      },
      (err) => {
        console.log("Error updating onboarding status", err);
      }
    );
  },

  updateAvatar({ commit }, avatar) {
    UserService.updateAvatar(avatar).then(
      (res) => {
        const user = res.data;
        commit("setUser", user);
      },
      (err) => {
        console.log("Error updating avatar", err);
      }
    );
  },

  updateAllowsNotifications({ commit }, allowsNotifications) {
    UserService.updateAllowsNotifications(allowsNotifications).then(
      (res) => {
        const user = res.data;
        commit("setUser", user);
      },
      (err) => {
        console.log("Error updating allows notifications", err);
      }
    );
  },

  justLoggedIn({ commit }) {
    commit("setJustLoggedIn", true);
  },
  noLongerJustLoggedIn({ commit }) {
    commit("setJustLoggedIn", false);
  },
};

const mutations = {
  setUser(state, user) {
    if (user) {
      state.user = user;
    }
  },
  setJustLoggedIn(state, justLoggedIn) {
    state.justLoggedIn = justLoggedIn;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
